import angular from 'angular';

function routes($urlRouterProvider, $stateProvider) {
  'ngInject';

  $urlRouterProvider.otherwise('/policeAddress');

  $stateProvider.state('policeAddress', {
    url: '/policeAddress',
    templateProvider: () =>
      import(/* webpackChunkName: "policeAddress" */ './police-address.pug').then(
        ({ default: tpl }) => tpl,
      ),
    controller: 'policeAddressCtrl as vm',
    requiredPermission: 'policeAddress',
    resolve: {
      loadCtrl: $ocLazyLoad =>
        Promise.all([
          import(/* webpackChunkName: "policeAddress" */ './police-address.controller'),
          import('../../extensions/init/ag-grid'),
          import('../../extensions/directives/select2'),
        ]).then(([module]) => {
          $ocLazyLoad.load({ name: module.name });
          return module.controller;
        }),
    },
  });
}

export default angular.module('app.policeAddress.routing', []).config(routes);
